import React, { useEffect, useState } from 'react'
import './edit-customer.scss'
import SinglePage from '../../components/common/page/SinglePage'
import { useNavigate, useParams } from 'react-router-dom'
import { customerAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import NormalInput from '../../components/common/inputs/NormalInput'
import SelectInput from '../../components/common/inputs/SelectInput'
import CustomerProfileCard1 from '../../components/user/customer-profile-card-1/CustomerProfileCard1'
import Spinner from '../../components/common/spinners/SpinWithMessage'
import { BiLoaderAlt } from 'react-icons/bi'
import { toCityNameFormate } from '../../assets/javascript/formate-functions'
import InputPhoneNumber from '../../components/common/inputs/InputMobileNumber'

const EditCustomer = () => {
    const { cid } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [form, setForm] = useState({});
    const [cities, setCities] = useState([]);
    const [pinCode, setPinCode] = useState([]);
    const [postList, setPostList] = useState([])
    const [loading, setLoading] = useState('fetch');

    const handleNormalChange = (e) => {
        if (e?.target?.name === 'city') {
            let selectedCity = null
            cities?.map((obj) => {
                if (obj.city_id === e.target.value) {
                    selectedCity = obj
                }
                return obj;
            })

            setForm({
                ...form,
                city: selectedCity?.city_name,
                city_id: selectedCity?.city_id,
                state: selectedCity?.state_name,
                pin_code: '',
            })
            setPinCode(selectedCity?.pin_codes || [])
            setPostList(selectedCity?.post_offices || [])

            return;
        }

        if (['contact_1', 'contact_2', 'whatsapp'].includes(e.name)) {
            setForm({
                ...form,
                [e?.name]: e?.number ? { country_code: e?.country_code || null, number: e?.number || null } : undefined
            })

            return;
        }

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading('submit')
        customerAxios.put('/profile', form).then(() => {
            toast.success('Updated!')
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
            setLoading('')
        })
    }

    useEffect(() => {

        customerAxios.get(`/profile?cid=${cid}`).then((response) => {
            if (response.data.cid) {
                const customerDetails = {
                    cid: response?.data?.cid || '',
                    full_name: response?.data?.full_name || '',
                    star_rate: response?.data?.star_rate || '',
                    first_name: response?.data?.first_name || '',
                    last_name: response?.data?.last_name || '',
                    address: response?.data?.address?.address || '',
                    place: response?.data?.address?.place || '',
                    post: response?.data?.address?.post ? toCityNameFormate(response?.data?.address?.post) : '',
                    pin_code: response?.data?.address?.pin_code || '',
                    land_mark: response?.data?.address?.land_mark || '',
                    state: response?.data?.address?.state_name || '',
                    city: response?.data?.address?.city_name || '',
                    city_id: response?.data?.address?.city_id || '',
                    contact_1: {
                        country_code: response?.data?.contact1_cc || '',
                        number: response?.data?.contact1 || '',
                    },
                    contact_2: {
                        country_code: response?.data?.contact2_cc || '',
                        number: response?.data?.contact2 || '',
                    },
                    whatsapp: {
                        country_code: response?.data?.whatsapp1_cc || '',
                        number: response?.data?.whatsapp1 || '',
                    },
                    purifier_customer_status: response?.data?.purifier_customer_status || '',
                    wh_customer_status: response?.data?.wh_customer_status || '',
                    note: response?.data?.note || ''
                }
                setData(customerDetails)
                setForm(customerDetails)

                customerAxios.get('/l/area?area_type=service').then((response) => {
                    // city
                    setCities(response?.data || [])
                    const currentCity = response?.data?.filter((obj) => obj?.city_id === customerDetails?.city_id)
                    setPinCode(currentCity?.[0]?.pin_codes || [])
                    setPostList(currentCity?.[0]?.post_offices || [])

                    setLoading('')
                })

            } else {
                toast.error('Not a valid CID')
                navigate('/')
                setLoading('')
            }
        }).catch((error) => {
            toast.error(error.message)
            navigate('/')
            setLoading('')
        })
        // eslint-disable-next-line
    }, [])

    return (
        <div className="edit-customer-div">
            <SinglePage titleArray={[`Edit customer - ${cid}`]}>
                {loading === 'fetch'
                    ? <>
                        <Spinner message='Fetch data...' spin={true} />
                    </>
                    : <>
                        <form action="" onSubmit={handleSubmit}>
                            <div className="profile-badge-div">
                                <CustomerProfileCard1 fullName={data?.full_name} starRate={data?.star_rate} cid={data?.cid}
                                    pr={data?.purifier_customer_status} wh={data?.wh_customer_status} />
                            </div>
                            <div className="inputs">
                                <NormalInput label='First name*' name='first_name' value={form?.first_name} onChangeFun={handleNormalChange} />
                                <NormalInput label='Last name*' name='last_name' value={form?.last_name} onChangeFun={handleNormalChange} />
                                <NormalInput label='Address' name='address' value={form?.address} onChangeFun={handleNormalChange} isRequired={false} />
                                <NormalInput label='Place*' name='place' value={form?.place} onChangeFun={handleNormalChange} />
                                <SelectInput label='City*' value={form?.city} name='city' values={cities?.map((obj) => ({
                                    option: obj?.city_name, value: obj?.city_id, selected: obj?.city_id === form?.city_id
                                }))}
                                    onChangeFun={handleNormalChange}
                                    firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />
                                <NormalInput label='State*' value={form?.state} name='state' />
                                <SelectInput label='Post office*' name='post' onChangeFun={handleNormalChange}
                                    values={postList?.map((value) => ({ option: value, value, selected: value?.toLowerCase() === form?.post?.toLowerCase() }))}
                                    firstOption={{ option: 'Choose...', value: '' }} />
                                <SelectInput label='Pin code*' name='pin_code' onChangeFun={handleNormalChange}
                                    values={pinCode?.map((value) => ({ option: value, value, selected: value === form?.pin_code }))}
                                    firstOption={{ option: 'Choose...', value: '' }} />
                                <NormalInput label='Land mark' name='land_mark' value={form?.land_mark} onChangeFun={handleNormalChange} isRequired={false} />

                                <InputPhoneNumber label={'Primary Number'} value={`${form?.contact_1?.country_code || ''}${form?.contact_1?.number || ''}`}
                                    onChange={handleNormalChange} onlyCountries={['in']} country={'in'} name={'contact_1'} required />
                                <InputPhoneNumber label={'Secondary Number'} value={`${form?.contact_2?.country_code || ''}${form?.contact_2?.number || ''}`}
                                    onChange={handleNormalChange} country={'in'} name={'contact_2'} />
                                <InputPhoneNumber label={'Whatsapp Number'} value={`${form?.whatsapp?.country_code || ''}${form?.whatsapp?.number || ''}`}
                                    onChange={handleNormalChange} country={'in'} name={'whatsapp'} />

                            </div>
                                <NormalInput label='Customer Note' name='note' value={form?.note} onChangeFun={handleNormalChange} isRequired={false} />
                            <div className="button-div">
                                <button type='submit'>{loading === 'submit' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Update"}</button>
                            </div>
                        </form>
                    </>}
            </SinglePage>
        </div>
    )
}

export default EditCustomer